

export const ToEst = (time: Date) => {
    const date = new Date(time);
    return date.toLocaleString('en-US', {
        timeZone: 'America/New_York',
    })

}